import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "react-select";
import Model from "../Model";
import DropzoneForContact from "../Contacts/DropzoneForContact";
import Images from "../../Images";

const SingleEntry = ({
  SingleEntryLoading,
  postSingleEntry,
  setOpenUploadModel,
  hostNamesandProvince,
}) => {
  const [uploadFile, setUploadFile] = useState("");

  const InitialValues = {
    eventName: "",
    province: "",
    totalAmount: "",
    gst: "",
    hst: "",
    qst: "",
  };

  const SubmitHandler = (values) => {
    postSingleEntry(values);
  };

  const UserList = [
    { value: "2", label: "Finance" },
    { value: "3", label: "Registrar" },
    { value: "4", label: "Ass. Registrar" },
    // { value: "Administrator", label: "Administrator" },
  ];

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setOpenUploadModel}>
      <Title>Add User</Title>

      {SingleEntryLoading && <Loading />}

      {!SingleEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="fName">First Name</Label>
                  <FieldWrapper>
                    <Field name="fName" id="fName" autoComplete="off" />
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="lName">Last Name</Label>
                  <FieldWrapper>
                    <Field name="lName" id="lName" autoComplete="off" />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>

              <InputGroup>
                <Label htmlFor="email">Email</Label>
                <FieldWrapper>
                  <Field
                    type="text"
                    name="email"
                    id="email"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label htmlFor="mobile">Phone Number</Label>
                <FieldWrapper>
                  <Field
                    type="number"
                    name="mobile"
                    id="mobile"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="type">User Type</Label>
                  <FieldWrapper $select={true}>
                    <Field required name="type" id="type" autoComplete="off">
                      {(props) => (
                        <Select
                          className="w-full h-full"
                          options={UserList}
                          onChange={(val) =>
                            props.form.setFieldValue("type", val.value)
                          }
                        />
                      )}
                    </Field>
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="password">Password</Label>
                  <FieldWrapper>
                    <Field
                      type="password"
                      name="password"
                      id="password"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Add</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center`;

export default SingleEntry;
